/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-await-in-loop */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */

type TypeOption = {
  dsDescricao: string;
  dsImagem: string;
  dsNome: string;
  flag_type_price: string;
  flgAtivo: string;
  idNivelCardapio: any;
  idOpcaoNivel: string;
  idOrigem: string;
  idRestaurante: string;
  qtItens: string;
  qtMaxOpcao: string;
  qtMinOpcao: string;
  vlItem: string;
};

const Additional = async (data: any) => {
  let vlAdditional = 0;

  for (let index = 0; index < data.length; index += 1) {
    vlAdditional +=
      parseFloat(
        data[index].vlAdicional ? data[index].vlAdicional : data[index].vlItem,
      ) * data[index].qtItens;
  }

  return vlAdditional;
};

const Flavor = async (data: any, tpCalcFlavor: any) => {
  let vlFlavorAverage = 0;
  let vlFlavorGreater = 0;

  for (let index = 0; index < data.length; index += 1) {
    if (parseFloat(data[index].vlSabor) > vlFlavorGreater) {
      vlFlavorGreater = parseFloat(data[index].vlSabor);
    }
    vlFlavorAverage += parseFloat(data[index].vlSabor);
  }

  if (parseInt(tpCalcFlavor, 10) == 0) {
    vlFlavorAverage /= data.length;
    return vlFlavorAverage;
  }
  return vlFlavorGreater;
};

const Option = async (data: TypeOption[]) => {
  let vlOption = 0;
  let vlOptionHigh = 0;
  let flag_type_price = 0;
  let qtSelected = 0;

  for (let index = 0; index < data.length; index += 1) {
    const dataOption = data[index];

    flag_type_price = parseInt(dataOption.flag_type_price, 10);

    switch (flag_type_price) {
      case 0:
        vlOption +=
          parseFloat(dataOption.vlItem) * parseInt(dataOption.qtItens, 10);
        break;
      case 1:
        vlOption = parseFloat(dataOption.vlItem);
        break;
      case 2:
        vlOption += parseFloat(dataOption.vlItem);
        qtSelected += 1;
        break;
      case 3:
        vlOption += parseFloat(dataOption.vlItem);
        qtSelected += 1;
        break;
      case 4:
        vlOption = parseFloat(dataOption.vlItem);
        if (vlOption > vlOptionHigh) {
          vlOptionHigh = vlOption;
        }
        break;
      case 5:
        vlOption = parseFloat(dataOption.vlItem);
        if (vlOption > vlOptionHigh) {
          vlOptionHigh = vlOption;
        }
        break;
      default:
        vlOption +=
          parseFloat(dataOption.vlItem) * parseInt(dataOption.qtItens, 10);
        break;
    }
  }

  if (flag_type_price == 2 || flag_type_price == 3) {
    if (qtSelected > 0) {
      vlOption /= qtSelected;
    }
  } else if (flag_type_price == 4 || flag_type_price == 5) {
    vlOption = vlOptionHigh;
  }

  return { vlOption, flag_type_price };
};

const CalcCartProduct = async (
  product: any,
  flavor: any,
  additional: any,
  optionLevel: any,
) => {
  let vlTotal = 0;
  let vlItemTotal = 0;
  let vlAdditional = 0;
  let vlFlavor = 0;

  vlItemTotal += parseFloat(product.vlItemOriginal);

  if (optionLevel.length > 0) {
    // Definindo explicitamente o tipo de arrOptionLevel
    const arrOptionLevel: { [key: string]: TypeOption[] } = {};
    const orderDefault: any[] = [];

    // Agrupando opções por idNivelCardapio e mantendo a ordem
    optionLevel.forEach((option: any) => {
      if (!arrOptionLevel[option.idNivelCardapio]) {
        arrOptionLevel[option.idNivelCardapio] = [];
        orderDefault.push(option.idNivelCardapio); // Manter a ordem de inserção
      }
      arrOptionLevel[option.idNivelCardapio].push(option);
    });

    // Processar os níveis na ordem original
    for (let i = 0; i < orderDefault.length; i += 1) {
      const key = orderDefault[i];
      const optionItem = arrOptionLevel[key];
      const resultOption = await Option(optionItem);
      const { vlOption } = resultOption;
      let { flag_type_price }: any = resultOption;

      flag_type_price = parseInt(flag_type_price, 10);

      switch (flag_type_price) {
        case 0:
          vlItemTotal += vlOption;
          break;
        case 1:
          vlItemTotal = vlOption;
          break;
        case 2:
          vlItemTotal += vlOption;
          break;
        case 3:
          vlItemTotal = vlOption;
          break;
        case 4:
          vlItemTotal += vlOption;
          break;
        case 5:
          vlItemTotal = vlOption;
          break;
        default:
          vlItemTotal += vlOption;
          break;
      }
    }
  }

  if (additional.length > 0) {
    const resultAdditional = await Additional(additional);

    vlAdditional = resultAdditional;
  }

  if (flavor?.length > 0) {
    const resultFlavor = await Flavor(flavor, product.tpCalculoSabor);
    vlFlavor = resultFlavor;
  }

  if (flavor.length > 0) {
    vlItemTotal = vlFlavor;
  }

  vlItemTotal += vlAdditional;

  vlItemTotal *= product.qtItens || 1;

  vlTotal += vlItemTotal;

  vlAdditional = 0;
  vlFlavor = 0;
  vlItemTotal = 0;

  return vlTotal;
};

export { Option, Additional, Flavor, CalcCartProduct };
